import type { CommentsChannelView } from '~publish/legacy/routes'

/**
 * Detect the current community view (comments list vs posts list) from the URL.
 *
 * Only inspects the segment immediately after `community` so that unrelated
 * routes containing "posts" (e.g. `/posts/:id/edit`) don't cause false positives.
 *
 * `by-post` maps to the `posts` view because we can't preserve a specific
 * post in the nav link — so we fall back to the posts listing.
 */
export function getCurrentCommunityView(pathname: string): CommentsChannelView {
  const segments = pathname.split('/').filter(Boolean)
  const communityIndex = segments.indexOf('community')
  if (communityIndex === -1) {
    return 'comments'
  }
  const viewSegment = segments[communityIndex + 1]
  if (viewSegment === 'posts' || viewSegment === 'by-post') {
    return 'posts'
  }
  return 'comments'
}
